import React from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

export default function Icon({ children, onClick, tooltip }) {
  return (
    <span
      onClick={onClick}
    >
      <Tooltip
        title={tooltip}
        interactive={false}
        theme="light"
      >
        {children}
      </Tooltip>
    </span>
  )
}
